
export const schedulerUrl = "http://localhost:12345/dolphinscheduler/ui";
export const projectId = "14152175415808";